$(document).ready(function () {
  $("body").on("click", ".buy-now", function () {
    var gokwikMid = $(this).attr("data-mid");
    var url = $(".buyNowUrl").val();
    var pId = $(".detail-section.product").attr("data-pid");
    var quantity = $(".quantity-select").val();

    $.spinner().start();
    $.ajax({
      url: url,
      type: "post",
      dataType: "json",
      data: {
        pId: pId,
        quantity: quantity,
      },
      success: function (res) {
        const events = ["buy_now", "add_to_cart", "begin_checkout"];
        events.forEach((event) => {
          const eventCategoryMap = {
            buy_now: "buyNow",
            add_to_cart: "addToCart",
            begin_checkout: "Checkout",
          };
          const eventData = {
            ...res.eventDataForGA,
            event,
            eventCategory: eventCategoryMap[event],
            currentPage: window.location.href,
          };

          if (event === "begin_checkout") {
            eventData.eventAction = "Begin Checkout";
          }

          window.dataLayer.push(eventData);
        });

        $.spinner().stop();
        gokwikSdk.initCheckout({
          environment: "sandbox",
          type: "merchantInfo",
          mid: gokwikMid,
          bannerMesseges: [
            "Sample message one",
            "Sample <b style = 'font-family: metropolisbold'>messages</b> two",
          ],
          merchantParams: {
            merchantCheckoutId: res.dwsid,
            basketId: res.tempBasketId,
          },
        });
      },
      error: function (err) {
        $.spinner().stop();
      },
    });
  });

  $("body").on("click", ".gokwik-checkout", function () {
    var gokwikMid = $(this).attr("data-mid");
    var url = $(".removeTempBasketUrl").val();
    var dwsid;
    var basketId;

    $.ajax({
      type: "GET",
      url: url,
      success: function (res) {
        if (res.success) {
          dwsid = res.dwsid;
          basketId = res.currentBasketId;

          gokwikSdk.initCheckout({
            environment: "sandbox",
            type: "merchantInfo",
            mid: gokwikMid,
            bannerMesseges: [
              "Sample message one",
              "Sample <b style = 'font-family: metropolisbold'>messages</b> two",
            ],
            merchantParams: {
              merchantCheckoutId: dwsid,
              basketId: basketId,
            },
          });
        }
      },
      error: function (err) {
        console.log("error result  " + JSON.stringify(err));
      },
    });
  });

  window.dataLayer = window.dataLayer || [];
  gokwikSdk.on("checkout-ready", function (response) {
    window.dataLayer.push({
      eventname: "checkoutReady",
    });

    var etmcUrl = $(".etmcUrl").val();

    $.ajax({
      url: etmcUrl,
      type: "POST",
      contentType: "application/json",
      dataType: "json",
      data: JSON.stringify({ items: response.items }),
      success: function (res) {
        var result = res;
        _etmc.push(["trackCart", { cart: res.convertedItems }]);
      },
      error: function (err) {
        var result = err;
        console.log("error result  " + JSON.stringify(result));
      },
    });
  });

  gokwikSdk.on("user-login-initiated", function (response) {
    window.dataLayer.push({
      eventname: "user-login-initiated",
    });
  });

  gokwikSdk.on("user-login-successful", function (response) {
    window.dataLayer.push({
      eventname: "userLoginSuccessful",
    });
  });

  gokwikSdk.on("address-add", function (response) {
    window.dataLayer.push({
      eventname: "address-add",
    });
  });

  gokwikSdk.on("address-selected", function (response) {
    var url = $(".createEventData").val();

    $.ajax({
      type: "GET",
      url: url,
      success: function (res) {
        res.eventDataForGA.currentPage = window.location.href;
        res.eventDataForGA.event = 'add_shipping_info';
        res.eventDataForGA.eventCategory = 'Checkout';
        res.eventDataForGA.eventAction = 'home'
        dataLayer.push(res.eventDataForGA);
      },
      error: function (err) {
        var result = err;
        console.log("error result  " + JSON.stringify(result));
      },
    });
  });

  gokwikSdk.on("coupon-applied", function (response) {
    window.dataLayer.push({
      eventname: "coupon-applied",
    });
  });

  gokwikSdk.on("coupon-removed", function (response) {
    window.dataLayer.push({
      eventname: "coupon-removed",
    });
  });

  gokwikSdk.on("coupon-invalid", function (response) {
    window.dataLayer.push({
      eventname: "coupon-invalid",
    });
  });

  gokwikSdk.on("payment-method-selected", function (response) {
    var url = $(".paymentDataUrl").val();

    $.ajax({
      url: url,
      type: "POST",
      contentType: "application/json",
      dataType: "json",
      data: JSON.stringify({ gkResponse: response }),
      success: function (res) {
        res.eventDataForGA.currentPage = window.location.href;
        res.eventDataForGA.event = 'add_payment_info';
        res.eventDataForGA.eventCategory = 'Checkout';
        res.eventDataForGA.eventAction = response.payment_method
        dataLayer.push(res.eventDataForGA);
      },
      error: function (err) {
        var result = err;
        console.log("error result  " + JSON.stringify(result));
      },
    });
  });

  gokwikSdk.on("payment-failure", function (response) {
    window.dataLayer.push({
      eventname: "payment-failure",
    });

    var form = $("<form></form>");
    var url = $(".failOrderUrl").val();
    form.attr("action", url);
    form.attr("method", "GET");

    var input1 = $("<input></input>")
      .attr("type", "hidden")
      .attr("name", "orderId")
      .attr("value", response.merchant_order_id);

    form.append(input1);

    $("body").append(form);
    form.submit();
  });

  gokwikSdk.on("order-complete", function (response) {
    window.dataLayer.push({
      eventname: "orderComplete",
      eventData: {
        merchant_order_id: response.merchant_order_id,
      },
    });

    console.log('Order Complete Response '+JSON.stringify(response));
    
    if (response.payment_status === "payment_successful") {
      var url = $(".changeStatusUrl").val();

      $.ajax({
        url: url,
        type: "post",
        dataType: "json",
        data: {
          orderId: response.merchant_order_id,
          token: response.merchant_order_details.token,
          amountPaid: response.total,
          payableAmount: response.payable_on_delivery,
          paymentGatewayPaymentId: response.transaction_id,
          paymentGatewaySignature: response.payment_method,
          gyftrMobileNo: response.phone,
          gyftrRemRefundableAmount: response?.reward?.items?.length ? response.reward.items[0].reward_amount : '',
          gyftrPartnerOrderId: response.gokwik_order_id,
          gyftrRedemptionTxnId: response.transaction_id
        },
        success: function (res) {
          var redirectUrl = $(".redirectUrlGokwik").val();
          var form = $("<form></form>");
          form.attr("action", redirectUrl);
          form.attr("method", "GET");

          var input1 = $("<input></input>")
            .attr("type", "hidden")
            .attr("name", "orderId")
            .attr("value", res.orderId);

          var input2 = $("<input></input>")
            .attr("type", "hidden")
            .attr("name", "token")
            .attr("value", res.token);

          form.append(input1);
          form.append(input2);

          $("body").append(form);
          form.submit();
        },
        error: function (err) {
          $.spinner().stop();
        },
      });
    }
  });

  gokwikSdk.on("checkout-close", function (response) {
    window.dataLayer.push({
      eventname: "checkoutClose",
    });
    window.location.reload();
  });

  gokwikSdk.on("navigation_payment_options", function (response) {
    window.dataLayer.push({
      eventname: "navigationPaymentOptions",
    });
  });

  gokwikSdk.on("checkout-initiation-failure", function (response) {
    window.dataLayer.push({
      eventname: "checkout-initiation-failure",
    });
    var form = $("<form></form>");

    var url = $(".redirectFailureUrl").val();
    form.attr("action", url);
    form.attr("method", "GET");

    $("body").append(form);
    form.submit();
  });

  gokwikSdk.on("customer-attached", function (response) {
    window.dataLayer.push({
      eventname: "customer-attached",
    });
  });

  gokwikSdk.on("native-redirection", function (response) {
    window.dataLayer.push({
      eventname: "nativeRedirection",
    });
    var form = $("<form></form>");

    var url = $(".redirectFailureUrl").val();
    form.attr("action", url);
    form.attr("method", "GET");

    $("body").append(form);
    form.submit();
  });
});
